// Оразмеряване на списъка с потребители в модалите за генериране на отчет
// (персонален и на заведението). Идеята е да НЯМА скрол: една колона побира
// 6 реда, затова над 6 потребителя списъкът минава в 2 колони, над 12 — в 3,
// а модалът се разширява заедно с тях; скрол се появява чак над 18. На тесен
// екран (<640px) няма място за колони — остава една и скролът идва след 6-ия.
export type UserListColumns = 1 | 2 | 3;

export const getUserListColumns = (
  userCount: number,
  isNarrow: boolean,
): UserListColumns => {
  if (isNarrow) return 1;
  if (userCount > 12) return 3;
  if (userCount > 6) return 2;
  return 1;
};

// Tailwind не разпознава композирани в движение класове → готови низове.
export const userListGridClass: Record<UserListColumns, string> = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
};

// Побира точно 6 реда (ред ≈ 50px + 6px междина); при повече от 6 реда в
// колона се появява скрол.
export const userListMaxHeightClass = "max-h-[330px]";

// Скролът работи, но лентата е скрита (както в TableList): scrollbar-width
// за Firefox/новите Chromium, ::-webkit-scrollbar за Safari.
export const userListScrollClass =
  "overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden";

// Ширина на antd модала според колоните. maxWidth: calc(100vw - 32px) в
// самите модали пази при по-тесен от ширината екран.
export const getReportModalWidth = (
  columns: UserListColumns,
  isMobile: boolean,
  isTablet: boolean,
): number | undefined => {
  if (isMobile) return undefined;
  if (columns === 3) return isTablet ? 900 : 1000;
  if (columns === 2) return isTablet ? 660 : 740;
  return isTablet ? 440 : 480;
};
